import { useCallback } from 'react';
import { setForecastDate as setForecastDateRedux } from 'redux/reducers/meteorologyAgroCultureIndexAreaReducer';
import {
  format,
  parse,
} from 'date-fns';
import { store } from 'redux/store';
import { CultureIndexAreaMap } from 'types/Meteorology/Agro/CultureIndex/Area/map';
import useForecastDates from '../useForecastDates';

export default function useForecastDate(map: CultureIndexAreaMap) {
  const { forecastDates } = useForecastDates();
  const availableDates = forecastDates.map((date) => parse(date, 'yyyy-MM-dd', new Date()));

  const setForecastDate = useCallback((forecastDate: Date | null) => {
    if (forecastDate) {
      store.dispatch(setForecastDateRedux({
        id: map.id,
        forecastDate: format(forecastDate, 'yyyy-MM-dd'),
      }));
    }
  }, [map]);

  const forecastDate : Date = map.params.forecastDate
    ? parse(map.params.forecastDate, 'yyyy-MM-dd', new Date())
    : new Date();

  return {
    availableDates,
    forecastDate,
    setForecastDate,
  };
}
